
export const stateFipsToName = {
  "01": "Alabama",
  "02": "Alaska",
  "04": "Arizona",
  "05": "Arkansas",
  "06": "California",
  "08": "Colorado",
  "09": "Connecticut",
  "10": "Delaware",
  "11": "District of Columbia",
  "12": "Florida",
  "13": "Georgia",
  "15": "Hawaii",
  "16": "Idaho",
  "17": "Illinois",
  "18": "Indiana",
  "19": "Iowa",
  "20": "Kansas",
  "21": "Kentucky",
  "22": "Louisiana",
  "23": "Maine",
  "24": "Maryland",
  "25": "Massachusetts",
  "26": "Michigan",
  "27": "Minnesota",
  "28": "Mississippi",
  "29": "Missouri",
  "30": "Montana",
  "31": "Nebraska",
  "32": "Nevada",
  "33": "New Hampshire",
  "34": "New Jersey",
  "35": "New Mexico",
  "36": "New York",
  "37": "North Carolina",
  "38": "North Dakota",
  "39": "Ohio",
  "40": "Oklahoma",
  "41": "Oregon",
  "42": "Pennsylvania",
  "44": "Rhode Island",
  "45": "South Carolina",
  "46": "South Dakota",
  "47": "Tennessee",
  "48": "Texas",
  "49": "Utah",
  "50": "Vermont",
  "51": "Virginia",
  "53": "Washington",
  "54": "West Virginia",
  "55": "Wisconsin",
  "56": "Wyoming",
};

/**
 * Maps each geography level to its unique shapefile key.
 * Keeps lookup consistent across layers.
 */
export const JOIN_KEY_MAP = {
    states:        { shapefile: "STATEFP" },
    counties:      { shapefile: "GEOID" },
    cd:            { shapefile: "GEOID" },
    zipcodes:      { shapefile: "GEOID20" },
    statesenate:   { shapefile: "GEOID" },
    statehouse:    { shapefile: "GEOID" },
    media_market:  { shapefile: "Key" },
};

/**
 * Normalize a feature’s ID across different shapefile levels.
 * Ensures IDs are consistent for joining metrics and GeoJSON.
 */
export const normalizeId = (level, props) => {
  const key = JOIN_KEY_MAP[level]?.shapefile || "id";
  let v = props?.[key];

  // Fallbacks for missing or malformed IDs
  if (v == null) {
    if (level === "counties" && props?.STATEFP != null && props?.COUNTYFP != null) {
      v = String(props.STATEFP).padStart(2, "0") + String(props.COUNTYFP).padStart(3, "0");
    } else if (level === "cd") {
      v = props?.GEOID;
    }
  }

  if (v == null) return null;

  const s = String(v);
  switch (level) {
    case "states":       return s.padStart(2, "0");
    case "counties":     return s.padStart(5, "0");
    case "cd":           return s.padStart(4, "0");
    case "zipcodes":     return s.padStart(5, "0");

    case "statesenate":   return s.padStart(5, "0");
    case "statehouse":    return s.padStart(5, "0");
    case "media_market":  return s.padStart(3, "0");

    default:             return s;
  }
};


export function normalizeAreaIdForLevel(level, id) {
    const s = String(id ?? "");
    if (level === "states") return s.padStart(2, "0");
    if (level === "media_market") return s.padStart(3, "0");
    if (level === "counties") return s.padStart(5, "0");
    if (level === "cd") {
      const padded = s.padStart(5, "0");
      // DC's delegate district: the model output codes it 1100 (state 11 +
      // "00"), Census TIGER geometry codes it 1198 (state 11 + "98"). Same
      // geography, two dialects — alias the data-side code onto the
      // geometry-side one so DC joins (it painted blank at CD level).
      return padded === "01100" ? "01198" : padded;
    }
    if (level === "zipcodes") return s.padStart(5, "0");
    if (level === "statesenate") return s.padStart(5, "0");
    if (level === "statehouse") return s.padStart(5, "0");
    return s;
}

export const rowsFromTable = (table) => {
  const cols = table.schema.fields.map(f => f.name);
  const rows = [];
  for (let i = 0; i < table.numRows; i++) {
    const obj = {};
    for (const c of cols) obj[c] = table.getChild(c).get(i);
    rows.push(obj);
  }
  return rows;
};
